import styled from 'styled-components'
import theme from 'styles/theme'
import { GatsbyImage } from 'gatsby-plugin-image'
import { rem } from 'polished'

export const Wrapper = styled.div`
  width: 100wv;

  ${theme.mediaQueries.medium} {
    margin-top: ${theme.space[6]};
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100wv;
`

export const SubstoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1180px;

  ${theme.mediaQueries.medium} {
    flex-direction: row;
    width: 1180px;
  }
`

export const StoryContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: ${theme.space[8]};

  ${theme.mediaQueries.medium} {
    width: 50%;
  }
`

export const StoryBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 50%;
  top: 0;
  left: 0;
  z-index: -1;
  background-color: ${(props) =>
    `#${props.isIntersecting ? props.backgroundColor : 'transparent'}`};

  transition: background 0.5s ease;
`

export const StoryTitle = styled.div`
  text-align: center;
  padding: ${theme.space[4]} 0 0 0;
  color: ${(props) =>
    props.isIntersecting ? props.theme.colors.lifeStyle : theme.colors.black}};
  word-break: break-word;

  transition: color 0.5s ease;
`

export const StoryDescription = styled.div`
  text-align: center;
  padding: ${theme.space[4]} 0 ${theme.space[6]} 0;
  word-break: break-word;

  p {
    ${theme.textStyles.body12};
    color: ${(props) =>
      props.isIntersecting
        ? props.theme.colors.lifeStyle
        : theme.colors.black}};
  }

  a {
    ${theme.textStyles.body12};
    color: ${(props) =>
      props.isIntersecting
        ? props.theme.colors.lifeStyle
        : theme.colors.black}};
  }

  transition: color 0.5s ease;
`

export const StoryImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 91.5vw;

  ${theme.mediaQueries.medium} {
    width: 338px;
  }
`

export const StoryImageTitle = styled.div`
  padding-top: ${theme.space[4]};
`

export const StoryImage = styled(GatsbyImage)`
  min-height: 300px;
  width: 91.5vw;
  aspect-ratio: 10 / 16;
  @supports not (aspect-ratio: 10 / 16) {
    ${(props) => `height: ${props.width * 1.6}px;`}
  }

  ${theme.mediaQueries.medium} {
    width: auto;
  }
`

export const ProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 0 0 ${theme.space[8]} 0;

  ${theme.mediaQueries.medium} {
    width: 50%;
    padding: 0 ${theme.space[8]} ${theme.space[8]} ${theme.space[8]};
  }
`

export const ProductCardContainer = styled.div`
  padding: 0 ${theme.space[4]} ${theme.space[6]} ${theme.space[4]};
  width: 100vw;
  min-height: 540px;

  ${theme.mediaQueries.medium} {
    min-height: initial;
    width: 50%;
  }
`

export const QuoteContainer = styled.div`
  width: 50%;
`

export const QuoteTitle = styled.div`
  padding-bottom: ${theme.space[1]};
`

export const QuoteBody = styled.div`
  p {
    ${theme.textStyles.title20};
    font-size: ${rem(20)};
  }

  a {
    color: ${(props) => `#${props.linkColor}`};
    text-decoration: none;
  }
`

export const FeaturedProductsContainer = styled.div`
  display: relative;
  width: 100%;
  text-align: center;
`

export const FeaturedProductsTitle = styled.div`
  text-align: center;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  max-width: 700px;
  padding: 0 ${theme.space[2]};
`

export const VideoContainer = styled.div`
  min-height: 300px;
  width: 91.5vw;

  ${theme.mediaQueries.medium} {
    width: auto;
  }
`

export default {
  Wrapper,
  Container,
  SubstoryContainer,
  StoryDescription,
  StoryTitle,
  FeaturedProductsContainer,
  StoryContainer,
  StoryBackground,
  StoryImage,
  StoryImageContainer,
  StoryImageTitle,
  ProductContainer,
  ProductCardContainer,
  QuoteContainer,
  QuoteTitle,
  VideoContainer,
}
